// import { toast } from 'react-toastify';
import { GOOGLE_OAUTH_CLIENT_ID, SK_userSession } from '../../data/config';
import { request } from '../../utils/request';

export const authWithGoogle = (origin: string): string => {
  const rootUrl = `https://accounts.google.com/o/oauth2/v2/auth`;

  const options = {
    redirect_uri: window.location.origin,
    client_id: GOOGLE_OAUTH_CLIENT_ID,
    response_type: 'id_token',
    prompt: 'consent',
    nonce: 'random_nonce_string',
    scope: [
      'https://www.googleapis.com/auth/userinfo.profile',
      'https://www.googleapis.com/auth/userinfo.email',
    ].join(' '),
    state: origin,
  };

  const qs = new URLSearchParams(options);
  return `${rootUrl}?${qs.toString()}`;
};

export const authGoogleUserWithAPI = async (token: string) =>
  request({
    method: 'POST',
    url: '/auth/sign-in/google',
    formData: {
      token,
      role_type: 'store_owner',
    },
    callback: () => {
      localStorage.removeItem(SK_userSession);
    },
    onError: (err) => {
      console.error(err.message);
      throw err;
    },
  });
